var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box"},[_c('h2',[_vm._v("Parser test")]),_c('div',{staticClass:"body"},[_c('product-query-assist',{attrs:{"product":_vm.product},model:{value:(_vm.querytext),callback:function ($$v) {_vm.querytext=$$v},expression:"querytext"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }